import { http } from '@/system/http';

export default {
    state: {
        results: [],
        pageSize: 10,
        loaded: false,
        loading: false,
        currentPage: 1,
        lastPage: false,
        loadingMore: false,
        showHelsenettAddressRegisterModal: false,
    },

    mutations: {
        setLoading (state, loading) {
            state.loading = loading;
        },

        setLoaded (state, loaded) {
            state.loaded = loaded;
        },

        setLoadingMore (state, loadingMore) {
            state.loadingMore = loadingMore;
        },

        incrementCurrentPage (state) {
            state.currentPage++;
        },

        resetCurrentPage (state) {
            state.currentPage = 1;
        },

        setResults (state, results) {
            if (state.currentPage > 1) {
                state.results = state.results.concat(results);
                return;
            }
            state.results = results;
        },

        addResults (state, results) {
            const existingHerIds = new Set(state.results.map(r => r.herId));
            const newResults = results.filter(result => !existingHerIds.has(result.herId));
            state.results.push(...newResults);
        },

        setLastPage (state, lastPage) {
            state.lastPage = lastPage;
        },

        setShowHelsenettAddressRegisterModal (state, show) {
            state.showHelsenettAddressRegisterModal = show;
        },
    },
    actions: {
        async getDataFromNhn({ commit }, { searchMode, query, excludeHerIds, subUserId, per_page = null, force = false }) {
            query = query.trim();
            if (!force && (!query || query.length < 3)) {
                commit('setLoaded', false);
                commit('setResults', []);
                return;
            }

            try {
                commit('setLoading', true);
                commit('setLoaded', false);
                commit('resetCurrentPage');
                let url = '/app/helsenett/address-register/search';
                url = per_page ? url + `?per_page=${per_page}` : url;
                const response = await http.post(url , {
                    searchMode: parseInt(searchMode),
                    query: query,
                    excludeHerIds: excludeHerIds,
                    subUserId: subUserId,
                });
                commit('setResults', response.data.data);
                commit('incrementCurrentPage');
                commit('setLastPage', response.data.last_page);
            } finally {
                commit('setLoading', false);
                commit('setLoaded', true);
            }
        },

        async loadMore ({ commit, state }, { searchMode, query }) {
            try {
                commit('setLoadingMore', true);
                const response = await http.post(`/app/helsenett/address-register/search?page=${state.currentPage}&per_page=${state.pageSize}`, {
                    searchMode: parseInt(searchMode), query
                });
                commit('incrementCurrentPage');
                commit('addResults', response.data.data);
                commit('setLastPage', response.data.last_page);
            } finally {
                commit('setLoadingMore', false);
            }
        },

        resetSearchResults ({ commit, dispatch }) {
            commit('setResults', []);
            commit('setLoaded', false);
            commit('setShowHelsenettAddressRegisterModal', false);
        },

        showHelsenettAddressRegisterModal ({ commit }, show) {
            commit('setShowHelsenettAddressRegisterModal', show);
        }
    }
}
